import { motion } from "framer-motion";
import { Overline } from "@/components/motion";
import { DynIcon } from "./iconMap";

export default function WhyChoose({ title, subtitle, items = [] }) {
  return (
    <section id="why-choose" data-testid="why-choose" className="relative py-24 sm:py-32 bg-[#14523d] text-[#fdfbf7] overflow-hidden">
      <div className="absolute inset-0 opacity-15 paper-grain pointer-events-none" />
      <div className="absolute -top-32 -left-24 w-[30rem] h-[30rem] rounded-full bg-[#d4af37]/10 blur-3xl" />
      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-[#d4af37]" />
            <span className="text-[11px] tracking-[0.34em] uppercase text-[#e8c970] font-semibold">Why Choose Us</span>
          </div>
          <h2 className="font-serif text-white text-4xl sm:text-6xl leading-[1.03] tracking-tight mt-5">
            {title || "The Legacy India Travel"} <span className="italic text-[#e8c970]">difference.</span>
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#d4af37]/20 border border-[#d4af37]/20">
          {items.map((it, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.05 }}
              className="bg-[#14523d] p-8 sm:p-10 group hover:bg-[#0e3a2b] transition-colors duration-500"
            >
              <span className="inline-flex items-center justify-center w-12 h-12 border border-[#d4af37]/50 text-[#e8c970] group-hover:bg-[#d4af37] group-hover:text-[#14523d] transition-colors">
                <DynIcon name={it.icon} className="w-5 h-5" />
              </span>
              <h3 className="font-serif text-2xl sm:text-3xl mt-5 leading-snug">{it.title}</h3>
              <p className="text-[#fdfbf7]/75 mt-3 leading-relaxed">{it.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
